import { Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'

/**
 * Displays transient snackbar notifications with consistent styling across the apps.
 *
 * Consolidates the `snackError` / `openErrorSnackbar` helpers that were previously
 * re-implemented in individual components and services.
 */
@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(private readonly snackBar: MatSnackBar) {}

  /**
   * Opens an error-styled snackbar. Falls back to `fallback` when `message` is empty — for
   * example a network failure that carries no server-provided message.
   *
   * @param message - the primary message to show (typically `err.error?.message`).
   * @param fallback - shown when `message` is null, undefined, or empty.
   * @param duration - how long the snackbar stays open, in milliseconds.
   */
  error(message: string | null | undefined, fallback = 'An error occurred', duration = 3000): void {
    this.snackBar.open(message || fallback, null, { panelClass: 'error', duration })
  }
}
